export default "__VITE_ASSET__DY2l5ut8__"